export default __webpack_public_path__ + "static/media/truck-appointment.05c753d5.svg";